import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.boundKeyHandler = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.boundKeyHandler)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundKeyHandler)
  }

  handleKeydown(event) {
    if (this.isTypingInFormField()) {
      return
    }

    if (event.ctrlKey || event.altKey || event.metaKey) {
      return
    }

    if (event.key === 't' || event.key === 'T') {
      event.preventDefault()
      $('#applyTemplateModal').modal('show')
    }
  }

  isTypingInFormField() {
    const element = document.activeElement
    const tagName = element?.tagName?.toUpperCase()

    return tagName === 'INPUT' || tagName === 'TEXTAREA' || element?.isContentEditable
  }
}
